import { createSelector } from "reselect";
import type { State as AccountModulesReducerState } from "../../reducers/accountModules";
import type { State } from "../../pages/AppStoreWrapper";
import type {
  Types as LinkingInfoTypes,
  Sorting as LinkingInfoSorting,
  Algorithm as LinkingInfoAlgorithm,
} from "../../components/LinkingInfoForm/types/LinkingInfoForm.types";
import type { ResourceFileFormats, DocumentAliasMode } from "../../actions/accountModules";

export const getLinkingAlgorithms = createSelector(
  (state: State): AccountModulesReducerState => state.account.accountModules,
  (accountModules: AccountModulesReducerState): Array<LinkingInfoAlgorithm> => {
    const linking = accountModules.get("linking");
    return linking?.algorithm || [];
  }
);

export const getLinkingSortings = createSelector(
  (state: State): AccountModulesReducerState => state.account.accountModules,
  (accountModules: AccountModulesReducerState): Array<LinkingInfoSorting> => {
    const linking = accountModules.get("linking");
    return linking?.sorting || [];
  }
);

export const getLinkingTypes = createSelector(
  (state: State): AccountModulesReducerState => state.account.accountModules,
  (accountModules: AccountModulesReducerState): Array<LinkingInfoTypes> => {
    const linking = accountModules.get("linking");
    return linking?.type || [];
  }
);

export const getResourceTypes = createSelector(
  (state: State): AccountModulesReducerState => state.account.accountModules,
  (accountModules: AccountModulesReducerState): Array<ResourceFileFormats> => {
    const resource = accountModules.get("resource");
    return resource?.fileFormat || [];
  }
);

export const getDocumentAliasMode = createSelector(
  (state: State): AccountModulesReducerState => state.account.accountModules,
  (accountModules: AccountModulesReducerState): DocumentAliasMode => {
    const document = accountModules.get("document");
    return (document?.documentAliasMode || "") as DocumentAliasMode;
  }
);
